const screenPadding = {
  base: "1rem",
  sm: "2rem",
  md: "2rem",
};

export default screenPadding;
